import { render, staticRenderFns } from "./corner2.vue?vue&type=template&id=31287c7e&scoped=true&"
import script from "./corner2.vue?vue&type=script&lang=js&"
export * from "./corner2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31287c7e",
  null
  
)

export default component.exports